import { saveToStorage } from "./utilities";

function storePrintValues(values) {
    saveToStorage("stayinginvested", values);
}

export { storePrintValues };
